module.exports = __webpack_public_path__ + "static/media/recipo.988d41b1.jpg";